import { motion } from "framer-motion";
import Image from "next/image";
import { useState } from "react";
import FlipText from "../Text/FlipText";

export default function BlogCard() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 0.3, ease: "easeInOut" }}
      viewport={{ once: true }}
      className="w-full h-[300px] relative z-10 group cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Image
        src="/images/banner-dark.jpg"
        width={0}
        height={0}
        sizes="100vw"
        className="w-full h-full grayscale group-hover:grayscale-0 transition duration-300"
        alt="Hello"
      />
      <div className="absolute bottom-8 left-0 !text-white px-8">
        <FlipText
          isHovered={isHovered}
          className="text-2xl"
          classNameStyleCustom="font-bold whitespace-pre inline-block"
        >
          Blog của tôi nè
        </FlipText>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque,
          exercitationem.
        </p>
      </div>
      <div className="absolute top-4 right-6 group-hover:-rotate-45 w-8 h-8 duration-300 transition-all">
        <Image
          alt="Arrow icon"
          src="/icons/arrow.svg"
          width={0}
          height={0}
          sizes="100vw"
          className="w-full h-full"
        />
      </div>
    </motion.div>
  );
}
